import { render } from "./UserEditPassword.vue?vue&type=template&id=0b5e727a&scoped=true"
import script from "./UserEditPassword.vue?vue&type=script&lang=js"
export * from "./UserEditPassword.vue?vue&type=script&lang=js"

import "./UserEditPassword.vue?vue&type=style&index=0&id=0b5e727a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b5e727a"]])

export default __exports__